import { useMutation, useQuery } from '@tanstack/react-query';
import {
  POST_RETRY,
  GET_INVOICES,
  GET_SEGMENTS,
  GET_VOUCHERS,
  POST_CONFIRM,
  POST_INIT_OTP,
  POST_OTP_LOGIN,
  GET_FINAL_INVOICE,
  POST_CREATE_TRANSACTIONS,
  POST_VALIDATE_SELECTION,
  POST_VALIDATE_SELECTIONS,
  GET_ADVERTISEMENT,
  POST_LOGIN_OPTIONS,
  POST_LOGIN_COMPLETE,
  POST_CHECK_WALLET_INQUIRY,
  POST_REQUEST_CALL,
  POST_CANCEL_CALL,
} from '@/constant/query-key';
import {
  postRetry,
  postInitOTP,
  getInvoices,
  getSegments,
  getVouchers,
  postConfirm,
  postOTPLogin,
  getFinalInvoice,
  postValidateSelection,
  postCreateTransactions,
  postValidateSelections,
  getAdvertisement,
  PostLoginOptions,
  PostLoginComplete,
  PostCheckWalletInquiry,
  PostRequestCall,
  PostCancelCall,
} from '@/services';
import {
  postOtpBodyType,
  createTransaction,
  postRetryBodyType,
  postInitOtpBodyType,
  validateSelectionBodyType,
  validateSelectionsBodyType,
  checkWalletInquiryBody,
} from '@/services/models/api.models';

export function usePostInitOTP() {
  return useMutation({
    mutationKey: [POST_INIT_OTP],
    mutationFn: (body: postInitOtpBodyType) => postInitOTP(body),
  });
}

export function usePostOTPLogin() {
  return useMutation({
    mutationKey: [POST_OTP_LOGIN],
    mutationFn: (body: postOtpBodyType) => postOTPLogin(body),
  });
}

export function usePostRetry() {
  return useMutation({
    mutationKey: [POST_RETRY],
    mutationFn: (body: postRetryBodyType) => postRetry(body),
  })
}

export function useGetInvoices() {
  return useQuery({
    queryFn: () => getInvoices(),
    queryKey: [GET_INVOICES],
    refetchOnWindowFocus: false,
    staleTime: 0,
    retry: false
  });
}

export function useGetSegments(enable: boolean) {
  return useQuery({
    queryFn: () => getSegments(),
    queryKey: [GET_SEGMENTS],
    enabled: enable,
    refetchOnWindowFocus: false,
    retry: false
  })
}

export function useGetVouchers(enable: boolean) {
  return useQuery({
    queryFn: () => getVouchers(),
    queryKey: [GET_VOUCHERS],
    enabled: enable,
    refetchOnWindowFocus: false,
    retry: false
  })
}

export function usePostValidateSelection() {
  return useMutation({
    mutationKey: [POST_VALIDATE_SELECTION],
    mutationFn: (body: validateSelectionBodyType) => postValidateSelection(body),
  })
}

export function usePostValidateSelections() {
  return useMutation({
    mutationKey: [POST_VALIDATE_SELECTIONS],
    mutationFn: (body: validateSelectionsBodyType) => postValidateSelections(body),
  })
}

export function usePostCreateTransactions() {
  return useMutation({
    mutationKey: [POST_CREATE_TRANSACTIONS],
    mutationFn: (body: createTransaction) => postCreateTransactions(body),
  })
}

export function usePostConfirm() {
  return useMutation({
    mutationKey: [POST_CONFIRM],
    mutationFn: (body: {WalletProviderOTP?:string}) => postConfirm(body),
  })
}

export function usePostLoginOptions() {
  return useMutation({
    mutationKey: [POST_LOGIN_OPTIONS],
    mutationFn: (body: {}) => PostLoginOptions(body),
  });
}

export function usePostLoginComplete() {
  return useMutation({
    mutationKey: [POST_LOGIN_COMPLETE],
    mutationFn: (body: {}) => PostLoginComplete(body),
  });
}

export function usePostRequestCall() {
  return useMutation({
    mutationKey: [POST_REQUEST_CALL],
    mutationFn: () => PostRequestCall({}),
  });
}

export function usePostCancelCall() {
  return useMutation({
    mutationKey: [POST_CANCEL_CALL],
    mutationFn: () => PostCancelCall({}),
  });
}

export function useGetFinalInvoice() {
  return useQuery({
    queryFn: () => getFinalInvoice(),
    queryKey: [GET_FINAL_INVOICE],
    refetchOnWindowFocus: false,
    retry: false,
  });
}


export function useGetAdvertisement(tag:number, pgc: string) {
  return useQuery({
    queryFn: () => getAdvertisement(tag, pgc),
    queryKey: [GET_ADVERTISEMENT, tag],
  });
}

export function usePostCheckWalletInquiry() {
  return useMutation({
    mutationKey: [POST_CHECK_WALLET_INQUIRY],
    mutationFn: (body: checkWalletInquiryBody) => PostCheckWalletInquiry(body),
  });
}